export const boxStyles = {
  mainOpen: {
    marginLeft: "240px",
  },
  mainClose: {
    marginLeft: "50px",
  },
};
